import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Header, Grid, TextArea, Dimmer, Loader } from "semantic-ui-react";
import UserInfo from '../Common/SharedComponents/UserInfo';
import AdminSidebar from '../Common/SharedComponents/AdminSidebar';
import AppContext from '../../AppContext';
import axiosInstance from '../../helpers/axiosInstance';
import SwitchTheme from '../Common/SharedComponents/SwitchTheme';

const ContactForm: React.FC = () => {
  const navigate = useNavigate();
  const { userInfo } = useContext(AppContext);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [embedCode, setEmbedCode] = useState<string>('');

  useEffect(() => {
    document.title = 'Contact Form - Adjure';
  }, []);

  useEffect(() => {
    if (userInfo !== undefined) {
      if (userInfo.IsAllOffices !== "True") {
        fetchData();
      } else {
        navigate('/');
      }
    }
  }, [userInfo, navigate]);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      await axiosInstance.get('adminsetting/GetEmbedCode').then(({ data, status }) => {
        if (status === 200) {
          setIsLoading(false);
          setEmbedCode(data);
        }
      })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
        });
    } catch (error: any) {
      setIsLoading(false);
      console.log(error);
    }
  }

  const selectAll = (event: any) => {
    event.target.select();
  }

  return (
    <section className="section" style={{
      minHeight: '100vh'
    }}>
      <div className="section__head">
        <div className="section__head-content">
          <Header as="h1">Contact Form</Header>
        </div>
        <div className="section__actions">
          <UserInfo />
          <SwitchTheme />
        </div>
      </div>
      <div className="section__body">
        <Dimmer.Dimmable as="div" dimmed={isLoading}>
          <Dimmer active={isLoading} inverted={true}>
            <Loader>Loading</Loader>
          </Dimmer>
          <Grid padded>
            <Grid.Row>
              <Grid.Column mobile={16} tablet={3} computer={3}>
                <AdminSidebar />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={13} computer={13}>
                <h2>Contact Form Embed Code</h2>
                <p>Here is the code for embedding your contact form on your website:</p>
                <TextArea
                  readOnly
                  name="description"
                  style={{ minHeight: 100, width: '50%', backgroundColor: '#efefef4d' }}
                  value={embedCode ? embedCode : ''}
                  onFocus={selectAll}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Dimmer.Dimmable>
      </div>
    </section>
  );
}

export default ContactForm;